import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { estimate, scrollTo } from 'estimate_list/libs/util'
//import { gaEvent } from 'libs/gtag'
import { setEstimateItems } from 'estimate_list/libs/action'

const AddCompare = ({ size, addCompareStyle, item,cnt_firm_b2 }) => {
    const dispatch = useDispatch()
    const addItem = () => {
        const estimateItems = estimate.addEstimateItem(item.item_id)
        dispatch(
            setEstimateItems({ estimateItems, type: 'add', itemId: item.item_id })
        )
        scrollTo('#estimateList')
    }

    return (
        <Button size={size}  addCompareStyle={addCompareStyle} type="button" className="button estimate_add_btn" onClick={addItem}
            isTest={cnt_firm_b2 > 0}
        >
            <span>상품견적 담기</span>
        </Button>
    )
}

AddCompare.defaultProps = {
    size: 38,
    style: null,
}

const Button = styled.div`
    &.estimate_add_btn {
        display: flex;
        position: ${props => props.addCompareStyle?.position ? props.addCompareStyle.position : 'relative'};
        ${props => props.addCompareStyle?.right ? `right : ${props.addCompareStyle.right}` : ''};
        border: 0;
        ${props => props.addCompareStyle?.estimate_add_btn_top ? `top : ${props.addCompareStyle.estimate_add_btn_top}px` : ''};
        //top : 0px;
        color: #fff;
        justify-content: center;
        align-items: center;
        width: ${props => props.size}px;
        height: ${props => props.size}px;
        font-size: ${props => props.size / 2}px;
        background-color: #418ded;
        cursor: pointer;

        &:before {
            font-family: 'ppingkr_v4';
            content: "";
            color: #fff;
        }
        &:hover {
            width: ${props => props.addCompareStyle?.hoverWidth ? props.addCompareStyle.hoverWidth : 109}px;
            padding: 0 0.5em;
            white-space: nowrap;
            z-index: 10;
            left : ${props => props.addCompareStyle ? props.addCompareStyle.button_right :''}px;

            span {
                display: block;
                margin: 0 0 0 0.5em;
                font-size: ${props => props.size / 2}px;
            }

            ${props => props.isTest &&
                `&:after {
                    content: '재고인증';
                    position: absolute;
                    left: 0;
                    transform: translateX(-100%);
                    width: 58px;
                    height: 25px;
                    text-align: center;
                    line-height: 25px;
                    color: #418ded;
                    background: #fff;
                    border: 1px solid #418ded
                }`
            }
        }
        span {
            display: none;
            font-size: ${props => props.size / 2.4}px;
        }
    }
`

export default AddCompare



// WEBPACK FOOTER //
// ./src/estimate_list/components/buttons/addCompare.js